"use client";
import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { Skeleton } from "@nxt-costco-com/forge-components";
import { ColorTextMedium } from "@nxt-costco-com/forge-design-tokens";
import { ScheduledHours } from "../../../Locations/WarehouseDrawer/WarehouseTile/ScheduledHours/index.js";
import { useBdWarehouseData } from "../../../../hooks/useBdWarehouseData/index.js";
const defaultScheduledHoursWidth = "180px";
function WarehouseHoursUI({
  url,
  headers
}) {
  const { warehouseData, isLoading } = useBdWarehouseData(url, headers);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    isLoading && /* @__PURE__ */ jsx(
      Skeleton,
      {
        width: defaultScheduledHoursWidth,
        variant: "textMultipleLines",
        lines: 1
      }
    ),
    warehouseData && /* @__PURE__ */ jsx(
      ScheduledHours,
      {
        warehouseData,
        hoursLabel: "",
        showHolidays: false,
        sxHoursLabel: { color: ColorTextMedium },
        locale: "en-us"
      }
    )
  ] });
}
export {
  WarehouseHoursUI
};
